import React from 'react';
import authRoles from 'app/auth/authRoles';

/**
 * Both pages were reachable by any signed-in account while the API behind them
 * refused everyone but accounting — so the wrong person got an empty screen and an
 * error rather than being told they could not be here.
 *
 * `payroll` is either scope: somebody with only their own is shown their own figures.
 */
const PayrollConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/payroll/outstandings',
      auth: authRoles.payroll,
      component: React.lazy(() => import('./outstandings/Outstandings'))
    },
    {
      path: '/payroll/paystubs',
      auth: authRoles.payroll,
      component: React.lazy(() => import('./paystubs/Paystubs'))
    }
  ]
};
export default PayrollConfig;
